import { BaseModel } from './base';

export class ApprovalLevel extends BaseModel {
  ApprovalPersonId: string;
  ApprovalpersonName: string;
  SubscriberId: string;
  SiteId: string;
}
